
import { Component, Vue } from "vue-property-decorator";
import validateDominicanId from "validacion-cedula-dominicana";
import VueRecaptcha from "vue-recaptcha";
import Swal from "sweetalert2";
import ConsultaFallecido, {
    ConsultaValidacionBeneficiarioResp,
} from "@/models/ConsultaFallecido";
import { AxiosResponse } from "axios";
import ServiceResponseEntity from "@/services/response-models/ServiceResponseEntity";
import AfiliadoService from "@/services/AfiliadoService";
import RecuperacionClave from "@/models/RecuperacionClave";

@Component({
    components: { VueRecaptcha },
})
export default class RecuperacionContrasena extends Vue {
    public afiliadoService: AfiliadoService = new AfiliadoService();
    public userIpAddress: string = null;
    public steps: {
        step1: boolean;
        step2: boolean;
        step3: boolean;
    } = {
        step1: true,
        step2: false,
        step3: false,
    };
    public recuperacionClave: RecuperacionClave = new RecuperacionClave();
    public consultaValidacionBeneficiarioResp: ConsultaValidacionBeneficiarioResp =
        new ConsultaValidacionBeneficiarioResp();
    public tiposEnvio: {
        c: string;
        e: string;
    } = {
        c: "C",
        e: "E",
    };
    public tipoMensaje: string = null;
    public loading: boolean = false;
    public showValidacionStep2 = false;

    get userHasContactInfo() {
        return (
            !!this.consultaValidacionBeneficiarioResp.celular ||
            !!this.consultaValidacionBeneficiarioResp.email1 ||
            !!this.consultaValidacionBeneficiarioResp.email2
        );
    }

    public async mounted(): Promise<void> {
        try {
            this.userIpAddress = (
                await this.afiliadoService.getUserIpAddress()
            ).data.ip;
        } catch (err) {
            this.loading = true;
            Swal.fire({
                title: "",
                text: "No se pudo obtener la dirección IP del consultante, por favor, recarga la página.",
                icon: "error",
            });
        }
    }
    public consultarBeneficiario(): void {
        this.loading = true;
		// if (!this.recuperacionClave.captchaToken) {
        //     Swal.fire({
        //         title: "",
        //         text: "Debe presionar el captcha para continuar!",
        //         icon: "warning",
        //     });
        //     this.loading = false;
        //     return;
        // }
        const cedula: string = this.recuperacionClave.cedulaBeneficiario;
        if (!validateDominicanId(cedula)) {
            this.loading = false;
            return;
        }
        const consultaFallecido = new ConsultaFallecido();
        consultaFallecido.cedulaBeneficiario = cedula;
        this.afiliadoService
            .consultarBeneficiario(consultaFallecido)
            .then(
                (
                    response: AxiosResponse<
                        ServiceResponseEntity<ConsultaValidacionBeneficiarioResp>
                    >
                ) => {
                    const consultaValidacionBeneficiarioResp =
                        response.data.entity;
                    this.loading = false;
                    if (!consultaValidacionBeneficiarioResp.estaRegistrado) {
                        Swal.fire({
                            title: "",
                            text: "Cédula no registrada en nuestra base de datos.",
                            icon: "warning",
                        });
                        return;
                    }
                    this.consultaValidacionBeneficiarioResp =
                        response.data.entity;
                    this.steps.step1 = false;
                    this.steps.step2 = true;
                }
            )
            .catch((err) => {
                this.loading = false;
                console.error(err);
            });
    }

    public hideFirstCharacters(text: string, charactersToHide: number): string {
        if (text) {
            return text
                .split("")
                .map((character: string, index: number) => {
                    if (index < charactersToHide) {
                        return "*";
                    } else {
                        return character;
                    }
                })
                .join("");
        } else {
            return "";
        }
    }

    public onCaptchaSuccess(token: any) {
        this.recuperacionClave.captchaToken = token;
    }

    public onCaptchaExpire(result: any) {
        this.recuperacionClave.captchaToken = "";
    }

    public maskEmail(email: string): string {
        if (!email) {
            return "";
        }
        const maskPlaceholder = "*";
        const emailSplitted = email.split("@");
        const emailSplittedByDot = emailSplitted[1].split(".");
        const topLevelDomainLength = ("." + emailSplittedByDot[1]).length;
        const emailUser: string = emailSplitted[0];
        const emailDomain: string = emailSplitted[1].substr(
            0,
            emailSplitted[1].length - topLevelDomainLength
        );
        const topLevelDomain: string = emailSplitted[1].substr(
            emailSplitted[1].length - topLevelDomainLength,
            topLevelDomainLength
        );
        const maskAllButFirstAndLast = (text: string) => {
            return text
                .split("")
                .map((character: string, index: number, arr: string[]) => {
                    const isFirst: boolean = index === 0;
                    const isLast: boolean = index === arr.length - 1;
                    return isFirst || isLast ? character : maskPlaceholder;
                })
                .join("");
        };
        const maskedEmailUser: string = maskAllButFirstAndLast(emailUser);
        const maskedEmailDomain: string = maskAllButFirstAndLast(emailDomain);
        return `${maskedEmailUser}@${maskedEmailDomain}${topLevelDomain}`;
    }
//aquiklk
    public returnToFirstStep(): void {
        this.onCaptchaExpire('');
		(this.$refs.recaptcha as VueRecaptcha).reset();
        this.steps.step1 = true;
        this.steps.step2 = false;
    }

    public async sendRecovery() {
		// if(!this.recuperacionClave.captchaToken){
		// 	Swal.fire({
        //         title: "",
        //         text: "Sesión expirada, favor consultar nuevamente",
        //         icon: "warning",
        //     });
		// 	this.returnToFirstStep();
        //     return;
		// }
        if (!this.recuperacionClave.tipoEnvio) {
            this.showValidacionStep2 = true;
            return;
        }
        
        // tipoEnvio is like C-8296010000
        let tipoEnvio = this.recuperacionClave.tipoEnvio[0];
        let valor = this.recuperacionClave.tipoEnvio.substring(2);
        this.recuperacionClave.valor = valor;
        this.recuperacionClave.tipoEnvio = tipoEnvio;
        switch (tipoEnvio) {
            case this.tiposEnvio.c:
                this.tipoMensaje = "SMS";
                break;
            case this.tiposEnvio.e:
                this.tipoMensaje = "correo";
                break;
        }

        await this.afiliadoService.recuperarClave(this.recuperacionClave);
        this.steps.step2 = false;
        this.steps.step3 = true;
    }

    public redirectToHome() {
        this.$router.push({
            path: "/login",
            query: {
                redirectToSiembra: "/default.aspx",
            },
        });
    }

    public goBack() {
        window.history.back();
    }
}
